/// <reference path="dates.ts" />
import { Dates } from "./dates";
// namespace Pacem {
export class NullChecker {
    static isNull(o) {
        return o === null || o === void 0;
    }
    static isEmpty(o) {
        try {
            return (Array.isArray(o) && o.length === 0)
                || (typeof o === 'string' && o === '')
                || (typeof o === 'object' && Object.keys(o).length === 0 && !Dates.isDate(o) && !(o instanceof RegExp) && !(o instanceof FileSystemDirectoryHandle) && !(o instanceof FileSystemFileHandle));
        }
        catch (e) {
            // Object.keys(null) would throw...
            return false;
        }
    }
    static isNullOrEmpty(o) {
        return NullChecker.isNull(o) || NullChecker.isEmpty(o);
    }
}
//}
